import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewLead from "../wizards/Lead/NewLead";

const styles = {
  dark: {
    navbar: {
      backgroundColor: "#1C1C1C",
      color: "#ffffff",
    },
  },
  light: {
    navbar: {
      color: "#000000",
    },
    navigationItemLink: {
      color: "#000000",
    },
    cmpButton: {
      color: "#000000",
      borderColor: "#000000",
    },
    navButton: {
      color: "#000000",
    },
    langNavHeader: {
      color: "#000000",
      borderColor: "#000000",
    }
  },
};

const SimpleLayout = () => {
  return (
    <>
      <Navbar theme="light" styles={styles} />

      <Outlet />
      <Footer />
      <NewLead />
    </>
  );
};

export default SimpleLayout;
